import i18n from '@hw-core/libs/i18n'
import { db } from '@/shared/services/firebase'

const header = {
  header: i18n.t('nav.headers.hr'),
  resource: 'HR',
  action: 'read',
}
const menuItems = [
  {
    title: i18n.t('applications.titles.menu_item'),
    icon: 'LayersIcon',
    route: 'apps-applications-list',
    resource: 'Applications',
    action: 'read',
  },
  {
    title: i18n.t('personels.titles.menu_item'),
    icon: 'UserIcon',
    route: 'apps-personels-list',
    resource: 'HR',
    action: 'read',
  },
  {
    title: i18n.t('communications.titles.menu_item'),
    icon: 'MailIcon',
    route: 'apps-communications-list',
    resource: 'Communications',
    action: 'read',
  },
  {
    title: i18n.t('documentRequests.titles.menu_item'),
    icon: 'BookIcon',
    route: 'apps-document-requests-list',
    resource: 'DocumentRequests',
    action: 'read',
    setBadgeCount: ({ role, callback }) => {
      if (role !== 'admin') {
        return
      }
      db.collection('documentRequests')
        .where('status', '==', 'open')
        .onSnapshot(snapshot => {
          const changes = snapshot.docChanges()
          if (changes.length > 0) {
            db
              .collection('documentRequests')
              .where('status', '==', 'open')
              .get()
              .then(collection => {
                let badgeUpdateCount = 0
                collection.forEach(doc => {
                  if (doc.exists) {
                    const request = doc.data()
                    // Set if there is user badge upates in a request
                    badgeUpdateCount += request.badgeHR ? 1 : 0
                  }
                })
                callback(badgeUpdateCount)
              })
          }
        })
    },
  },
]

export default { header, menuItems }
